/* tslint:disable */
/* eslint-disable */
/**
 * Melco Digitizing APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DigitizingserviceMelcoDigitizingModelsOrderAttachment
 */
export interface DigitizingserviceMelcoDigitizingModelsOrderAttachment {
    /**
     * 
     * @type {string}
     * @memberof DigitizingserviceMelcoDigitizingModelsOrderAttachment
     */
    attachment_base64?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DigitizingserviceMelcoDigitizingModelsOrderAttachment
     */
    file_name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DigitizingserviceMelcoDigitizingModelsOrderAttachment
     */
    file_extension?: string | null;
}

export function DigitizingserviceMelcoDigitizingModelsOrderAttachmentFromJSON(json: any): DigitizingserviceMelcoDigitizingModelsOrderAttachment {
    return DigitizingserviceMelcoDigitizingModelsOrderAttachmentFromJSONTyped(json, false);
}

export function DigitizingserviceMelcoDigitizingModelsOrderAttachmentFromJSONTyped(json: any, ignoreDiscriminator: boolean): DigitizingserviceMelcoDigitizingModelsOrderAttachment {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'attachment_base64': !exists(json, 'attachment_base64') ? undefined : json['attachment_base64'],
        'file_name': !exists(json, 'file_name') ? undefined : json['file_name'],
        'file_extension': !exists(json, 'file_extension') ? undefined : json['file_extension'],
    };
}

export function DigitizingserviceMelcoDigitizingModelsOrderAttachmentToJSON(value?: DigitizingserviceMelcoDigitizingModelsOrderAttachment | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'attachment_base64': value.attachment_base64,
        'file_name': value.file_name,
        'file_extension': value.file_extension,
    };
}


